module.exports = __webpack_public_path__ + "img/Aqua.67b05d20.svg";